import { render, staticRenderFns } from "./ProtocoloAcoes.vue?vue&type=template&id=7e9b2ecd&scoped=true&"
import script from "./ProtocoloAcoes.vue?vue&type=script&lang=js&"
export * from "./ProtocoloAcoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e9b2ecd",
  null
  
)

export default component.exports